/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Cancel_YesInputs */



/**
* | output |
* | --- |
* | "Yes, cancel round" |
*
* @param {Rounds_Cancel_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_cancel_yes = /** @type {((inputs?: Rounds_Cancel_YesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Cancel_YesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, annuler la ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, cancelar ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sim, cancelar rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, annulla round")
	return /** @type {LocalizedString} */ ("Yes, cancel round")
});